import React, { Component } from "react";
import { tokens, format_date, GET, getStorage, toFixed, replaceTextHTML, loading } from "../components/CustomComponent.js";
import LOGO from "../assets/images/logo.png";
import THBText from "thai-baht-text";
import "../assets/css/bootstrap.css";
import "../assets/css/index.css";

const size = {
  A4: { width: 1116, height: 1578 },
  A5: { width: 1116, height: 1578, zoom: 0.5 },
  "4.5 x 5.5 นิ้ว": { width: 1116, height: 1371, zoom: 0.385 },
  "9 x 11 นิ้ว": { width: 1116, height: 1371, zoom: 0.77 },
  "9 x 5.5 นิ้ว": { width: 1116, height: 806, zoom: 0.77 },
};

export default class PaymentHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null,
      setting: {
        size: "A4", paddingLeft: 0, paddingRight: 0, paddingTop: 0, paddingBottom: 0,
        header_1: { status: true, title: "-โลโก้" },
        header_2: { status: true, title: "" },
        header_3: { status: true, title: "" },
        header_4: { status: true, title: "-ใบเสร็จรับเงิน" },
        header_5: { status: true, title: "-เลขที่" },
        header_6: { status: true, title: "-วันที่" },
        header_7: { status: true, title: "-ได้รับเงินจาก" },
        header_8: { status: true, title: "-ที่อยู่" },
        header_9: { status: true, title: "-ชำระโดย" },
        header_10: { status: true, title: "-วันที่" },
        th_1: { status: true, title: "-ลำดับ" },
        th_2: { status: true, title: "-รายการ" },
        th_3: { status: true, title: "-เลขมาตรจดครั้งนี้" },
        th_4: { status: true, title: "-เลขมาตรจดครั้งก่อน" },
        th_5: { status: true, title: "-จำนวนหน่วยที่ใช้" },
        th_6: { status: true, title: "-รวมเป็นเงิน" },
        tr_1: { status: true, title: "-ค่าน้ำประปา" },
        tr_2: { status: true, title: "-ค่าบริการรักษาอุปกรณ์น้ำ" },
        tr_3: { status: true, title: "-ค่าบริการจัดเก็บขยะ" },
        tr_4: { status: true, title: "-ค่าใช้จ่ายส่วนกลาง" },
        tr_5: { status: true, title: "-ค้างชำระ" },
        tr_6: { status: true, title: "-อื่นๆ" },
        tr_6_1: { status: true, title: "-ค่าต่อกลับมิเตอร์" },
        tr_6_2: { status: true, title: "-ค่าปรับล่าช้า" },
        tr_6_3: { status: true, title: "-ค่าเบี้ยประกัน" },
        tr_6_4: { status: true, title: "-ค่าบริการเคเบิล" },
        tr_6_5: { status: true, title: "" },
        tr_7: { status: true, title: "-รายการลดหนี้" },
        tr_8: { status: true, title: "-รายการเพิ่มหนี้" },
        tr_9: { status: true, title: "-รวมเป็นเงิน" },
        tr_10: { status: true, title: "-ปรับปรุงยอดเงิน" },
        tr_11: { status: true, title: "-รวมเป็นเงินทั้งสิ้น" },
        footer_1: { status: true, title: "-จำนวนเงิน (ตัวอักษร)" },
        footer_2: { status: true, title: "" },
        footer_3: { status: true, title: "-ลงชื่อ" },
        footer_4: { status: true, title: "" },
        footer_5: { status: true, title: "" },
      },
    };
  }

  async componentDidMount() {
    loading(false); // เรียกใช้ปิด loading ทันทีตั้งแต่เข้ามา
    await this.Get();
    
    const localData = localStorage.getItem("DATA_");
    if (localData) this.setState({ data: JSON.parse(localData) });

    await replaceTextHTML();
    setTimeout(() => window.print(), 1000);
  }

  Get = async () => {
    loading(true);
    let result = await GET(tokens, `v1/TH/document-manage/detail/custom-document/${getStorage("project_id")}`);
    if (result?.status && result.data?.data?.receipt) {
      this.setState({ setting: result.data.data.receipt });
    }
    loading(false);
  };

  // ใบเสร็จ 1 แผ่น — เรียกซ้ำได้หลายใบในหน้าเดียว (พิมพ์ทั้งหมดทีเดียว)
  renderSheet = (d, sheetIndex, sheetCount) => {
    const s = this.state.setting;
    
    // Helper สำหรับซ่อน Element
    const chk = (key) => (!s[key]?.status ? "d-none" : "");
    const hideHeaderTop = (!s.header_1?.status && !s.header_2?.status && !s.header_3?.status && !s.header_5?.status && !s.header_6?.status) ? "d-none" : "";
    const hideHeader56 = (!s.header_5?.status && !s.header_6?.status) ? "d-none" : "";
    const hideHeader7to10 = (!s.header_7?.status && !s.header_8?.status && !s.header_9?.status && !s.header_10?.status) ? "d-none" : "";

    // Helper สำหรับคำนวณลำดับข้อ 
    const rIdx = (keys) => keys.reduce((sum, k) => sum + (s[k]?.status ? 1 : 0), 0);
    const tr1 = ['tr_1'];
    const tr2 = [...tr1, 'tr_2'];
    const tr3 = [...tr2, 'tr_3'];
    const tr4 = [...tr3, 'tr_4'];
    const tr5 = [...tr4, 'tr_5'];
    const tr6 = [...tr5, 'tr_6'];
    const tr7 = [...tr6, 'tr_7'];
    const tr8 = [...tr7, 'tr_8'];

    // คำนวณวันที่และยอดรวม
    const nextMonth = d?.water_current_month ? new Date(new Date(d.water_current_month).setMonth(new Date(d.water_current_month).getMonth() + 1)) : null;
    const grandTotal = Number(d?.total || 0) + Number(d?.change_satang || 0);

    return (
      <div className="w-100">
        <div 
          className={`mx-auto bg-white border-bottom ${s.size === "9 x 5.5 นิ้ว" ? "pdf-small" : "pdf"}`}
          style={{
            ...size[s.size || "A4"],
            paddingLeft: Number(s.paddingLeft),
            paddingRight: Number(s.paddingRight),
            paddingTop: Number(s.paddingTop),
            paddingBottom: Number(s.paddingBottom),
          }}>
          
          <table className="table table-bordered mb-0 header">
            <tbody>
              <tr className={`border-bottom-0 ${hideHeaderTop}`}>
                <td rowSpan={2}>
                  <div className="d-flex align-items-center">
                    <img src={getStorage("picture_paper") || LOGO} style={{ width: 92, height: 92, objectFit: "contain", marginRight: 6 }} alt="LOGO" className={`bg-contain ${chk("header_1")}`} />
                    <div>
                      <h2 className={`fw-bold px-2 mb-0 ${chk("header_2")}`}>{s.header_2?.title || ""}</h2>
                      <div className={`px-2 ${chk("header_3")}`}>
                        {s.header_3?.title?.split("\n").map((e, i) => <div key={i}>{e}</div>)}
                      </div>
                    </div>
                  </div>
                </td>
                <td className={`wpx-250 text-center border-bottom-0 ${chk("header_4")}`}>
                  <h2 className="fw-bold mb-0">ใบเสร็จรับเงิน</h2>
                </td>
              </tr>
              <tr className={hideHeader56}>
                <td className="border-bottom-0 wpx-250">
                  <div className={chk("header_5")}>เลขที่ : {d?.number}</div>
                  <div className={chk("header_6")}>วันที่ : {d?.date}</div>
                </td>
              </tr>
              <tr className={hideHeader7to10}>
                <td className="border-bottom-0">
                  <div className={chk("header_7")}>ได้รับเงินจาก : {d?.cutomer_name}</div>
                  <div className={chk("header_8")}>ที่อยู่ : {d?.cutomer_address}</div>
                </td>
                <td className="border-bottom-0 wpx-250">
                  <div className={chk("header_9")}>ชำระโดย : {d?.payment}</div>
                  <div className={chk("header_10")}>วันที่ : {d?.payment_date}</div>
                </td>
              </tr>
            </tbody>
          </table>

          <table className="table table-bordered mb-0">
            <tbody>
              <tr>
                <td className={`text-center wpx-50 ${chk("th_1")}`}>ลำดับ<br/><span> </span></td>
                <td className={`w-100 ${chk("th_2")}`}>รายการ<br/><span> </span></td>
                <td className={chk("th_3")}>
                  <div className="text-nowrap mx-1">
                    เลขมาตรจดครั้งนี้<br />วันที่ {format_date(d?.water_current_month)}
                  </div>
                </td>
                <td className={chk("th_4")}>
                  <div className="text-nowrap mx-1">
                    เลขมาตรจดครั้งก่อน<br />วันที่ {format_date(d?.water_last_month || d?.water_current_month)}
                  </div>
                </td>
                <td className={`text-center wpx-130 ${chk("th_5")}`}>จำนวนหน่วยที่ใช้<br/><span> </span></td>
                <td className={`text-center wpx-120 ${chk("th_6")}`}>รวมเป็นเงิน<br/><span> </span></td>
              </tr>
              <tr className={chk("tr_1")}>
                <td className={`pt-1 text-center ${chk("th_1")}`}>1</td>
                <td className={`pt-1 border-right-0 w-100 ${chk("th_2")}`}>ค่าน้ำประปา ประจำเดือน {format_date(d?.water_current_month, "mmmm yyyy")}</td>
                <td className={`text-right ${chk("th_3")}`}>{d?.current_gauge_number}</td>
                <td className={`text-right ${chk("th_4")}`}>{d?.last_gauge_number}</td>
                <td className={`text-right ${chk("th_5")}`}>{d?.unit_used}</td>
                <td className={`text-right ${chk("th_6")}`}>{toFixed(d?.water_bill)}</td>
              </tr>
              <tr className={chk("tr_2")}>
                <td className={`pt-1 text-center ${chk("th_1")}`}>{rIdx(tr2)}</td>
                <td className={`pt-1 border-right-0 w-100 ${chk("th_2")}`}>ค่าบริการรักษาอุปกรณ์น้ำ {format_date(d?.water_current_month, "mmmm yyyy")}</td>
                <td className={`border-left-0 border-right-0 text-right ${chk("th_3")}`}></td>
                <td className={`border-left-0 border-right-0 text-right ${chk("th_4")}`}></td>
                <td className={`border-left-0 border-right-0 text-right ${chk("th_5")}`}></td>
                <td className={`text-right ${chk("th_6")}`}>{toFixed(d?.equipment_maintenance_fee)}</td>
              </tr>
              <tr className={chk("tr_3")}>
                <td className={`pt-1 text-center ${chk("th_1")}`}>{rIdx(tr3)}</td>
                <td className={`pt-1 border-right-0 w-100 ${chk("th_2")}`}>ค่าบริการจัดเก็บขยะ {format_date(d?.water_current_month, "mmmm yyyy")}</td>
                <td className={`border-left-0 border-right-0 text-right ${chk("th_3")}`}></td>
                <td className={`border-left-0 border-right-0 text-right ${chk("th_4")}`}></td>
                <td className={`border-left-0 border-right-0 text-right ${chk("th_5")}`}></td>
                <td className={`text-right ${chk("th_6")}`}>{toFixed(d?.waste_cost)}</td>
              </tr>
              <tr className={chk("tr_4")}>
                <td className={`pt-1 text-center ${chk("th_1")}`}>{rIdx(tr4)}</td>
                <td className={`pt-1 border-right-0 w-100 ${chk("th_2")}`}>ค่าใช้จ่ายส่วนกลาง ประจำเดือน {format_date(nextMonth, "mmmm yyyy")}</td>
                <td className={`border-left-0 border-right-0 text-right ${chk("th_3")}`}></td>
                <td className={`border-left-0 border-right-0 text-right ${chk("th_4")}`}></td>
                <td className={`border-left-0 border-right-0 text-right ${chk("th_5")}`}></td>
                <td className={`text-right ${chk("th_6")}`}>{toFixed(d?.common_expenses)}</td>
              </tr>
              <tr className={chk("tr_5")}>
                <td className={`pt-1 text-center ${chk("th_1")}`}>{rIdx(tr5)}</td>
                <td className={`pt-1 border-right-0 w-100 ${chk("th_2")}`}>ค้างชำระจำนวน {Math.max((d?.water_list?.length || 1) - 1, 0)} งวด</td>
                <td className={`border-left-0 border-right-0 text-right ${chk("th_3")}`}></td>
                <td className={`border-left-0 border-right-0 text-right ${chk("th_4")}`}></td>
                <td className={`border-left-0 border-right-0 text-right ${chk("th_5")}`}></td>
                <td className={`text-right ${chk("th_6")}`}>{toFixed(d?.water_list_price)}</td>
              </tr>
              <tr className={chk("tr_6")}>
                <td className={`pt-1 text-center ${chk("th_1")}`}>{rIdx(tr6)}</td>
                <td className={`pt-1 border-right-0 w-100 ${chk("th_2")}`}>อื่นๆ</td>
                <td className={`border-left-0 border-right-0 text-right ${chk("th_3")}`}></td>
                <td className={`border-left-0 border-right-0 text-right ${chk("th_4")}`}></td>
                <td className={`border-left-0 border-right-0 text-right ${chk("th_5")}`}></td>
                <td className={`text-right ${chk("th_6")}`}></td>
              </tr>
              <tr className={chk("tr_6_1")}>
                <td className={`pt-1 text-center ${chk("th_1")}`}>{rIdx(tr6)}.{rIdx(['tr_6_1'])}.</td>
                <td className={`pt-1 border-right-0 w-100 ${chk("th_2")}`}>ค่าต่อกลับมิเตอร์</td>
                <td className={`border-left-0 border-right-0 text-right ${chk("th_3")}`}></td>
                <td className={`border-left-0 border-right-0 text-right ${chk("th_4")}`}></td>
                <td className={`border-left-0 border-right-0 text-right ${chk("th_5")}`}></td>
                <td className={`text-right ${chk("th_6")}`}>{toFixed(d?.meter_connect_cost)}</td>
              </tr>
              <tr className={chk("tr_6_2")}>
                <td className={`pt-1 text-center ${chk("th_1")}`}>{rIdx(tr6)}.{rIdx(['tr_6_1', 'tr_6_2'])}.</td>
                <td className={`pt-1 border-right-0 w-100 ${chk("th_2")}`}>ค่าปรับล่าช้า</td>
                <td className={`border-left-0 border-right-0 text-right ${chk("th_3")}`}></td>
                <td className={`border-left-0 border-right-0 text-right ${chk("th_4")}`}></td>
                <td className={`border-left-0 border-right-0 text-right ${chk("th_5")}`}></td>
                <td className={`text-right ${chk("th_6")}`}>{toFixed(d?.total_cost_late)}</td>
              </tr>
              <tr className={chk("tr_6_3")}>
                <td className={`pt-1 text-center ${chk("th_1")}`}>{rIdx(tr6)}.{rIdx(['tr_6_1', 'tr_6_2', 'tr_6_3'])}.</td>
                <td className={`pt-1 border-right-0 w-100 ${chk("th_2")}`}>ค่าเบี้ยประกัน</td>
                <td className={`border-left-0 border-right-0 text-right ${chk("th_3")}`}></td>
                <td className={`border-left-0 border-right-0 text-right ${chk("th_4")}`}></td>
                <td className={`border-left-0 border-right-0 text-right ${chk("th_5")}`}></td>
                <td className={`text-right ${chk("th_6")}`}>{toFixed(d?.fire_cost)}</td>
              </tr>
              <tr className={chk("tr_6_4")}>
                <td className={`pt-1 text-center ${chk("th_1")}`}>{rIdx(tr6)}.{rIdx(['tr_6_1', 'tr_6_2', 'tr_6_3', 'tr_6_4'])}.</td>
                <td className={`pt-1 border-right-0 w-100 ${chk("th_2")}`}>ค่าบริการเคเบิล</td>
                <td className={`border-left-0 border-right-0 text-right ${chk("th_3")}`}></td>
                <td className={`border-left-0 border-right-0 text-right ${chk("th_4")}`}></td>
                <td className={`border-left-0 border-right-0 text-right ${chk("th_5")}`}></td>
                <td className={`text-right ${chk("th_6")}`}>{toFixed(d?.cable_cost)}</td>
              </tr>
              <tr className={chk("tr_6_5")}>
                <td className={`pt-1 text-center ${chk("th_1")}`}>{rIdx(tr6)}.{rIdx(['tr_6_1', 'tr_6_2', 'tr_6_3', 'tr_6_4', 'tr_6_5'])}.</td>
                <td className={`pt-1 border-right-0 w-100 ${chk("th_2")}`}>{s?.tr_6_5.title}</td>
                <td className={`border-left-0 border-right-0 text-right ${chk("th_3")}`}></td>
                <td className={`border-left-0 border-right-0 text-right ${chk("th_4")}`}></td>
                <td className={`border-left-0 border-right-0 text-right ${chk("th_5")}`}></td>
                <td className={`text-right ${chk("th_6")}`}>{toFixed(d?.other_income)}</td>
              </tr>
              <tr className={chk("tr_7")}>
                <td className={`pt-1 text-center ${chk("th_1")}`}>{rIdx(tr7)}</td>
                <td className={`pt-1 border-right-0 w-100 ${chk("th_2")}`}>รายการลดหนี้</td>
                <td className={`border-left-0 border-right-0 text-right ${chk("th_3")}`}></td>
                <td className={`border-left-0 border-right-0 text-right ${chk("th_4")}`}></td>
                <td className={`border-left-0 border-right-0 text-right ${chk("th_5")}`}></td>
                <td className={`text-right ${chk("th_6")}`}>{((d?.reduce_debt || 0) + (d?.add_on_reduce_debt || 0)) > 0 ? "-" : ""}{toFixed((d?.reduce_debt || 0) + (d?.add_on_reduce_debt || 0))}</td>
              </tr>
              <tr className={chk("tr_8")}>
                <td className={`pt-1 text-center ${chk("th_1")}`}>{rIdx(tr8)}</td>
                <td className={`pt-1 border-right-0 w-100 ${chk("th_2")}`}>รายการเพิ่มหนี้</td>
                <td className={`border-left-0 border-right-0 text-right ${chk("th_3")}`}></td>
                <td className={`border-left-0 border-right-0 text-right ${chk("th_4")}`}></td>
                <td className={`border-left-0 border-right-0 text-right ${chk("th_5")}`}></td>
                <td className={`text-right ${chk("th_6")}`}>{toFixed((d?.add_debt || 0) + (d?.add_on_add_debt || 0))}</td>
              </tr>
            </tbody>
          </table>

          <table className="table table-bordered mb-0 w-100">
            <tbody>
              <tr>
                <td colSpan={rIdx(['th_1', 'th_2', 'th_3', 'th_4'])} rowSpan={3} className="border-0">
                  <div className="d-flex">
                    <div className="w-100">
                      <div className={`w-100 d-flex position-relative mt-3 text-nowrap ${chk("footer_1")}`}>
                        จำนวนเงิน (ตัวอักษร)
                        <div className="w-100 pl-1 position-relative">
                          ....................................................................................
                          <span className="position-absolute" style={{ left: 6, bottom: 4 }}>
                            {THBText(grandTotal)}
                          </span>
                        </div>
                      </div>
                      <div className={`text-wrap ${chk("footer_2")}`} style={{ maxWidth: 490 }}>
                        {s.footer_2?.title?.split("\n").map((e, i) => <div key={i}>{e}</div>)}
                      </div>
                    </div>
                    <div className="text-center">
                      <br /><br />
                      <div className={`text-nowrap ${chk("footer_3")}`}>ลงชื่อ...............................................ผู้รับเงิน</div>
                      <div className={chk("footer_4")}>({s.footer_4?.title})</div>
                      <div className={chk("footer_5")}>{s.footer_5?.title}</div>
                    </div>
                  </div>
                </td>
                <td className={`text-right border-top-0 wpx-130 pr-1 border-0 ${chk("tr_9")}`}>รวมเป็นเงิน</td>
                <td className={`text-right border-top-0 wpx-120 ${chk("tr_9")}`}>{toFixed(d?.total)}</td>
              </tr>
              <tr className={chk("tr_10")}>
                <td className="text-right border-top-0 wpx-130 pr-1 border-0">ปรับปรุงยอดเงิน</td>
                <td className="text-right border-top-0 wpx-120">{toFixed(d?.change_satang)}</td>
              </tr>
              <tr className={chk("tr_11")}>
                <td className="text-right border-top-0 wpx-130 pr-1 border-0">รวมเป็นเงินทั้งสิ้น</td>
                <td className="text-right border-top-0 wpx-120">{toFixed(grandTotal)}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  render() {
    // ข้อมูลอาจเป็นใบเดียว (object) หรือหลายใบ (array) — พิมพ์ทั้งหมดจะส่งมาเป็น array
    const list = Array.isArray(this.state.data) ? this.state.data : [this.state.data];
    return (
      <>
        {list.map((d, i) => (
          // ขึ้นหน้าใหม่ระหว่างใบ ใบสุดท้ายไม่ต้อง กันหน้าเปล่าท้ายเอกสาร
          <div key={i} style={{ pageBreakAfter: i < list.length - 1 ? "always" : "auto" }}>
            {this.renderSheet(d, i, list.length)}
          </div>
        ))}
      </>
    );
  }
}